/* eslint-disable @typescript-eslint/no-magic-numbers */
import { styled } from '../../../../../../theme/styled';
import { RANGE_FILTER_EDGE_DISABLED_OPACITY } from '../const';
import { RangeInputStateProps } from '../model';

export const RangeInputEdge = styled('div', {
  name: 'RangeInput',
  slot: 'Edge',
})<{ ownerState: RangeInputStateProps }>(({ theme, ownerState }) => {
  if (ownerState.variant === 'minimal') {
    return {
      opacity: ownerState.disabled ? RANGE_FILTER_EDGE_DISABLED_OPACITY : 1,
    };
  }

  const { size } = ownerState;
  const py = size === 'normal' ? 13 : 10;

  return {
    ...theme.typography[size === 'normal' ? 'body bold' : 'caption bold'],
    flex: '0 0 50%',
    paddingTop: py,
    paddingBottom: py,
    paddingLeft: size === 'normal' ? 24 : 16,
  };
});
